import { useState, useEffect } from "react";
import { ImageOff } from "lucide-react";
import { fileUrl } from "@/lib/api";

const SmartImage = ({ src, alt = "", className = "", iconClassName = "w-6 h-6" }) => {
  const [err, setErr] = useState(false);
  const url = fileUrl(src);

  useEffect(() => setErr(false), [src]);

  if (!src || err) {
    return (
      <div className={`flex items-center justify-center bg-muted text-muted-foreground/60 ${className}`} data-testid="image-fallback">
        <ImageOff className={iconClassName} />
      </div>
    );
  }
  return <img src={url} alt={alt} onError={() => setErr(true)} loading="lazy" className={className} />;
};

export default SmartImage;
